export function SmsTermsAndConditions() {
    return (
        <div className="font-mono mx-auto px-4 py-10 leading-relaxed text-sm">
            <h1 className="text-2xl font-bold mb-6">SMS Terms &amp; Conditions</h1>

            <p className="mb-2"><strong>Effective Date:</strong> 02-12-2025</p>
            <p className="mb-6"><strong>Last Updated:</strong> 02-12-2025</p>

            <h2 className="text-xl font-bold mt-8 mb-3">1. Overview</h2>
            <p className="mb-4">
                By opting in to receive SMS messages from Netstratum Technologies (“we,” “us,” “our”), you agree to these SMS Terms &amp; Conditions. These terms apply to all SMS communications sent by us.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-3">2. Types of Messages You Can Expect</h2>
            <p className="mb-2">
                By providing your phone number and opting in, you may receive SMS messages including, but not limited to -
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
                <li>Customer support responses</li>
                <li>Appointment reminders</li>
                <li>Account notifications</li>
                <li>Service updates</li>
                <li>Promotional or marketing messages (if applicable)</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-3">3. Message Frequency</h2>
            <p className="mb-4">
                Message frequency may vary depending on your interaction with us. You may receive multiple messages per week depending on your activity and preferences.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-3">4. Message &amp; Data Rates</h2>
            <p className="mb-4">
                Message and data rates may apply based on your mobile carrier’s terms. Netstratum Technologies is not responsible for any charges incurred by your mobile provider.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-3">5. Opt-In Consent</h2>
            <p className="mb-2">
                By submitting your phone number through our website forms and checking the SMS consent box, you:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
                <li>Authorize Netstratum Technologies to send SMS messages to your number</li>
                <li>Confirm that you are the owner or authorized user of the phone number</li>
                <li>Understand that consent is not a condition of purchase</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-3">6. Opt-Out Instructions</h2>
            <p className="mb-2">
                You can opt out of receiving SMS messages at any time.
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
                <li>To unsubscribe: Reply STOP to any message</li>
                <li>After opting out, you will receive a confirmation message and no further messages will be sent</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-3">7. Help &amp; Support</h2>
            <p className="mb-2">If you need assistance:</p>
            <ul className="list-disc pl-6 mb-4 space-y-1">
                <li>Reply HELP to any SMS message</li>
                <li>
                    Or contact us at: sales@netstratum.com
                    <br />
                    Website: https://netstratum.com/home
                </li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-3">8. Privacy Policy</h2>
            <p className="mb-4">
                Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your information -
                <br />
                https://netstratum.com/privacy-policy
            </p>

            <h2 className="text-xl font-bold mt-8 mb-3">9. Data Sharing</h2>
            <p className="mb-4">
                We do not sell, rent, or share your mobile number with third parties for their marketing purposes. We may share your information with service providers who assist in delivering SMS messages.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-3">10. Supported Carriers</h2>
            <p className="mb-4">
                SMS services may not be available on all carriers. Delivery is subject to your mobile provider’s network availability.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-3">11. Changes to These Terms</h2>
            <p className="mb-4">
                We may update these SMS Terms &amp; Conditions at any time. Updates will be posted on this page with the revised effective date.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-3">12. Contact Information</h2>
            <p className="mb-2">
                If you have any questions about these Terms &amp; Conditions, you can contact us:
            </p>
            <p className="mb-4">
                Netstratum Technologies
                <br />
                Email: sales@netstratum.com
                <br />
                Website: https://netstratum.com/home
            </p>
        </div>
    )
}